import React from 'react';
import Banner from '../components/Banner';
import About from '../components/About';
import CraftsmanshipSection from '../components/CraftsmanshipSection ';
import CuratedClassics from '../components/CuratedClassics';
import CategorySection from '../components/CategorySection';
import CustomerTestimonials from '../components/CustomerTestimonials';
import ContactSection from '../components/ContactSection';

const Home = () => {
  return (
    <>
      <Banner />
      <About />
      <CraftsmanshipSection/>
      <CuratedClassics />
      <CategorySection />
      <CustomerTestimonials />
      <ContactSection />
    </>
  );
};

export default Home;